import { PromoCodeInput } from '../../lib/types/models/promo-code/promo-code-input'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updatePromoCode(data: UpdateInput<PromoCodeInput>) {
  const { id, ...rest } = data
  return restApiClient.url(constructApiUrl(API.promoCodes.update.url, { id })).patch(rest)
}
